module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Three")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Headquarters, Army of the Susquehanna"), _c('br'), _vm._v(" Carlisle")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterDateline1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("August 22, 1863"), _c('br'), _vm._v(" 9:00 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("P.M")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/US.jpg"
    }
  }), _vm._v(" The evening air was beginning to cool as he stepped out of the Carlisle army barracks, which had become his headquarters for the night. The corridor reeked of coal oil. A rolled-up newspaper, half burnt and then crushed, lay by the doorway, as if the rebs were going to burn the place then changed their minds. Whoever it was who had spared the building, he was grateful to him. The barracks was a fine old part of army history.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He lit a cigar and leaned against a pillar on the veranda, drawing the smoke in, sighing as he exhaled. He actually felt relaxed, all the weeks of tension, of waiting, what seemed to be interminable waiting, were over. They were on the move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been a good day’s march. McPherson’s Corps had made over twenty five miles and camped ten miles southwest, at Centerville, and just behind him was Burnside’s Ninth. Ord’s men were still filing into Carlisle, and as he stood on the veranda, he watched them pass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The town was rich, prosperous, not really touched by the war. Gaslight illuminated the main thoroughfare, this incredible valley pike, the type of road he’d have given a right arm for while struggling through the back lanes and swamps of Louisiana and Mississippi. Broad, well macadamized, the crushed limestone pavement glittering in the glow of the gaslight.")]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "549",
      "src": "Images/50.jpg",
      "width": "325"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pb"
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The troops marched by in good order, their spirits up. They were on the move and in the East. All day long the men he had brought with him from the Mississippi campaign had been in high spirits. Though over eighty degrees, the air was relatively dry. There were no foul humors in this Pennsylvania air carrying ague or yellow jack. For them twenty-five miles in such conditions was all in a day’s work, though some had found the paved pike to be hard on the feet after the soft mud or powder of western roads.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What had captivated him and his army was the outright celebration of the citizenry. The pike was lined with thousands of civilians. They had been behind the rebel lines for over a month, and though Lee’s men had treated them with the utmost respect, still it had been an occupying army, and now the liberators had come. It was a heady experience for all of them, civilians, soldiers, and even their general. For the first time on a campaign march they had been greeted as friends and not as alien invaders.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That thought, of being aliens in their own country, had often troubled him. Nearly twenty years earlier, during the buildup before the war with Mexico, he had spent a winter in Louisiana and had found it to be a pleasant memory, of cool winter nights and days usually filled with a nice touch of warmth when compared to Ohio or the freezing nights at the Point. Back then they had been treated as heroes about to go off to war. But those days were long gone. Not since the start of all this current misery had he seen such a march as they had experienced this day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pretty girls, many wearing patriotic ribbons of red, white, and blue, stood at farm gates, waving flags, cheering as each regiment passed. Mothers had looked on smilingly, passing out fresh-baked biscuits and bread; little boys had run up and down along the fencerows bordering the pike, laughing and playing friendly pranks. When the march broke for ten minutes’ rest at the end of every hour, civilians had mingled freely among the men, bearing buckets of cool fresh well water and passing out yet more food.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So many soldiers in the ranks who were fathers found themselves, for a few minutes, transported back home, a child in their lap, tickling it, trying to get the infant or toddler to smile, and everyone laughing even when the child burst into tears and reached for its mother. Men began taking bullets out of a cartridge box, tearing them open and tossing a handful of loose powder into a quickly made fire to give the children a thrill as it burst with a puff of sulfurous smoke, then passing the minié ball to some wide-eyed boy as a souvenir. So many were doing this that word passed down the ranks that the practice had to be stopped before someone got hurt, and besides, multiplied a hundred thousand times, it was enough ammunition to keep an entire brigade on the firing line for a long day’s fight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the bugles and drums sounded for the march to resume more than one man had tears in his eyes as he hugged and kissed a child who had been “his” for ten brief minutes. Younger men, boys of seventeen and eighteen, fell in love a dozen times that day, for at each stop there was a pretty lass, scores of pretty lasses. At such a moment all the restraints and decorum were set aside for a few minutes, though parents still kept a watchful eye, usually chatting with a captain or older sergeant as they watched. Boys who at home had stammered at the sight of a girl now boldly asked their names, how old they were, and if they had any brothers or sweethearts in the army. Girls looked into young soldiers’ eyes and would not turn away, would smile, offer kind words, perhaps even the touch of a hand to a cheek or even a chaste kiss and a tearful, “Good luck soldier. I’ll pray for you tonight.” Addresses were hurriedly scribbled and exchanged, with the usually unfulfilled promise of writing after “all this is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so the columns would form up and move on, passing through small villages of prosperous homes, past rich farms with neatly painted barns as big as churches. The fences bordering the pike were sturdy, well-built affairs of post and rail, enclosing orchards, wheat fields, and corn head high on the other side. The fences were often piled thick with honeysuckle in bloom and morning glories fading in the midday heat. The air was rich with the scents of an abundant land, of ripening apples, corn, flowers, and over all a sheen of softness, almost of a memory forming that could haunt those who outlived the weeks ahead, haunting them fifty years hence with dreams of at least one day when war did have a touch of glory to it as they marched ever west and south.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The column, stretching back twenty miles, all the way to Harrisburg, had thus moved throughout the day, thousands of rifles on shoulders swaying, sparkling as they caught and reflected the sunlight. Behind each brigade moved a couple of dozen wagons, the limit set by Grant before the march, one wagon with additional ammunition for each regiment, a second wagon for regimental supplies, and one ambulance per regiment for the surgeon, his equipment, and room enough for four men to ride who might be too sick to keep up with the day’s march. It was a lean army marching fast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cresting low rises along the pike, a soldier could stop for a moment, looking back and then forward. As far as the eye could reach there were the long serpentine columns, dark blue, dull white canvas tops of wagons, the glint of bronze from batteries of Napoleon twelve-pounders, and always the flags. On this first day of march, a march carrying them down through loyal Pennsylvania, all the flags were uncased and held high, the light breeze out of the southwest gently lifting the banners.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("National colors, the flag of the Union, state flags, many never seen before by the civilians, flags of Wisconsin, Iowa, Michigan, and Illinois mixed in with the more familiar banners of Ohio, New York, and, of course, Pennsylvania. Most of the flags were shot-torn, some little more than tattered rags, which had been lovingly patched, sewn, and resewn by those who bore them. Faded gold lettering was emblazoned upon them, names of distant battles from what seemed almost to be another war…Fort Henry, Fort Donelson, Shiloh, Corinth, Jackson, and in new, yet-to-fade letters, Vicksburg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The colorful new flags of divisions and corps marked the head of each column, boys by the side of the road eagerly arguing with each other at the sight of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Red means First Division, blue Second Division, and that is Thirteenth Corps!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, Jimmie, you darn fool, white is Second and blue is Third, and I tell you that is Ninth Corps!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the passage of the colored division of Ninth Corps many at first stood silent, for such a sight had never been seen before, colored men, in uniform, carrying rifles on their shoulders and heading to war.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The men of that division, knowing they were being more closely watched than others, made it a point to march in proper style, rifles shouldered, not slung, hour after hour sergeants chanting the cadence, “Your left, your left, your left, right, left.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At the front of each regiment were brand-new national colors, beside them the unique yellow regimental flags of the United States Colored Troops. No battle honors were emblazoned on them yet, but all knew they soon would be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the first regiment in that division passed through hamlets and towns, past farms and workshops, most onlookers stood silent. But the sight of them, their new uniforms, the way they marched, keeping step, thousands of them, made their mark, and by the time the second brigade of the division passed, scattered applause would break out, and then cheers as the men, thousands of voices joined together, would sing “The Battle Hymn of the Republic.” “He has sounded forth the trumpet that shall never sound retreat….”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They must have sung it twenty times that day, each time as heartfelt as the last, and those lining the road joined in. And each time as they finished there was a strange, momentary silence. White citizens of a republic locked in the third year of a desperate war, looking now upon black men who perhaps indeed were the major cause of that war, armed and heading south. Such a sight would have been unimaginable passing through Pennsylvania only a few years before, but all things change, and war brings far more changes than anyone ever expects.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their passage carried that message, that realization. More than one person watching them pass had lost a son, a brother, a husband to the inferno, and some felt tears come to their eyes. Perhaps, after all, there was worth in their loss; perhaps these men represented that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the men of Third Division, Ninth Corps, this was not just a war about the preserving of the Union, it was a war of liberation. When someone cried out, “Good luck, soldier,” they felt a swelling pride within.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For those in that column that one word, “soldier,” carried with it a weight undreamed of by those who cried it. It was no longer “boy,” or even a kindly “uncle,” or the dark, bitter insult of “hey, nigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now it was “soldier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And so this first day of the campaign had passed, hard marching to be certain, but lighthearted. For so many, somehow, war again seemed to have to it some distant glory, a thrill down the spine as song would sweep through the ranks. There was, there had to be, a meaning to what they were doing now; perhaps all the suffering might be leading toward something beyond them as individuals. They were swept up in this vast undertaking, joined together in a single spirit, the soul of the Union, and it gave to them meaning. It might bring them to death, to that terrifying moment when, a limb gone, life’s blood flowed into the dust, but that was tomorrow. For the more philosophical, there was the thought as well that though death did indeed come to all men they would forever have this moment—and because of it, a hundred or, a hundred and fifty years hence, they would be remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A captain with an Illinois regiment, a man of some schooling, would recite poetry to his men as they marched. Sometimes they’d listen, sometimes not; sometimes they’d laugh a bit derisively; on occasion the silence would mean deep thought. “We few, we happy few, we band of brothers,” he said today. And Grant, standing at the bridge across the Susquehanna as they passed by just before dawn, had heard those words, coming louder as the regiment approached, then drifting off as they continued on. The words had stayed in his heart throughout the day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The soldiers had marched from before dawn well into the twilight of evening before breaking at last and going into camp with word that they would roust out at four in the morning to start again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Cumberland Valley was broad, relatively flat, a dozen miles wide. From Harrisburg to Carlisle it spread almost due west, then gradually began to arc to the southwest and then south, a broad open avenue that pointed eventually to the Potomac, to Maryland and Virginia beyond. As they moved down the valley the mountains that eventually would be the Catoctin Range stood to their left, a natural barrier that on the other side was still rebel territory.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The column marching past the Carlisle barracks thinned out as the wagons of the last brigade in line passed. At the end rode a unit of the provost guards, shepherding along those who had fallen out during the day because of illness and the heat. More than one of the guards had an exhausted man riding behind him on the rump of his horse. There had been almost no straggling this first day; that would come later as the relentless pace Grant had planned took its toll. Today had been easy for men well rested and eager. Two weeks from now it might be a different story.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General Grant?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An officer was approaching out of the twilight, the glow from the gaslights reflecting the glint of a single star on each shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant nodded and returned the man’s salute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, I’m Henry Hunt. You sent word for me to report.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was over a week ago, General Hunt. What kept you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, sir. The doctor said it was a touch of typhoid. I thought you received my telegram about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Most likely lost in all the confusion, Hunt. Never mind that, though. Are you fit now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant looked at him closely, and for a second there was the memory of Herman Haupt, dead last week from dysentery. Anyone who served in the army sooner or later was stricken by the typhoid or dysentery, an occupational hazard that killed more than the bullets did.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Walk with me, Hunt.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant stepped down from the veranda. The excitement in the town was beginning to die down, but curious civilians still lined the streets. He turned away and started toward the darkness of the parade field, Hunt by his side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The last glow of twilight in the west was fading away, the sky overhead dark, clear with stars, the moon yet to rise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“General, I know you are a good man. Your record at Malvern Hill, at Cemetery Hill the first day at Gettysburg, proved that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What happened at Union Mills?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tell me everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir,” and for fifteen minutes he talked, Grant did not interrupt as Hunt described the debacle which had unfolded, the bombardment which had failed to dislodge Lee, and the horror of watching the futile charge go forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He finally fell silent. Grant, having finished his cigar, reached into his breast pocket, pulled out a silver case, opened it, gave Hunt a cigar, and took another for himself. Henry snapped a lucifer with his thumbnail, sparking it to light, illuminating the two of them as they puffed their cigars to life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A few questions,” Grant said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anything, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Could Meade have won? Or let me put it another way. When did it begin to go wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, I really don’t like speaking poorly of the dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was a brother officer. If the roles were reversed right now—if it was I who were dead, and Meade in command, he’d ask the same question.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry nodded in reluctant agreement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The entire army should have been on the move as soon as word arrived that we were being flanked at Gettysburg,” Henry said. “If so, the following morning we could have cut Lee in half, his troops strung out on thirty miles of road from just outside Westminister clear back to Gettysburg. We’d have had him for certain then.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know about that,” Grant said softly, gazing up at the stars.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You are talking about Meade not acting like Meade. I suspect our rival somewhere over there”—he looked at Hunt while pointing off to the east—“Lee, had the measure of the Army of the Potomac before even one man stepped out on that incredible march to Union Mills. You must admit, Lee was masterful in that campaign.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir, he was,” Hunt said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He knew Meade would be slow to react, perhaps even to the point of first seeking a council of war, not fully yet in command, his fellow corps commanders still his peers rather than his subordinates. He knew Sickles would be impetuous—that is clearly evident from how he played him at Gunpowder River—but that Meade would rein him in.” He stopped and puffed on his cigar for a moment. “General Lee had the measure of all of you from the start and played it accordingly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant sighed, and went on. “I remember once, down in Mexico, after the fighting stopped, some darn fool officers decided to go hunting. But it wasn’t a hunt. They got their men to go up into the hills, form a line, and drive the game toward them. It was a slaughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The memory of it sickened him. How anyone could take pleasure in killing a dumb creature driven by fear was beyond him. War was little better.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was your Army of the Potomac,” Grant said coldly. “You were boxed and driven.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That has always bedeviled us,” Hunt sighed. “It’s as if Lee is always sitting in the corner at our meetings, wandering our camps at night. He seems to know even before we know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant slapped the side of his leg with his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That stops now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You speak of Lee as if he is a ghost or one of those mind readers at a county fair.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir, it was like that,” Henry said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That bothers you, Hunt?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They were good men, sir. Damn good men. Warren, Reynolds, the boys with my command. They deserved better. A damn sight better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They will get it,” Grant said calmly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not those who are dead, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The dead are behind us, Hunt. What concerns you and me is now, and I tell you this, if you are to join my command, it stops now. I want you to understand that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you want me then, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For what, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What would you suggest?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Artillery of course, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was my intention.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry grinned. After his dismissal from the Army of the Potomac by Sickles he thought he would never get a chance for action again. Grant was now giving him that chance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll confess, Hunt, out west, in those forests, those bayous and swamps, artillery wasn’t much use, too much of a tangle and too often slowed us down. I understand it’s different here, and frankly I can already see that just with today’s ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, this is the best damn artillery ground of the war, right here, clear down into northern Virginia. Almost all the land is cleared. You’ll notice the lay of the land, sir. Ridgelines tend to run south to north, or southwest to northeast, spaced at good range, every four hundred to a thousand yards or so. It’s damn good ground for guns.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And Lee has your guns now, doesn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Henry, his spirit broken by that comment, said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How would you organize yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What would be your preference in organization of artillery for this army?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you have with you, sir?” Henry replied, filled again with enthusiasm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have twenty-three batteries, a hundred and thirty-eight guns—eighteen batteries of newly forged three-inch rifles, or Parrott guns, the rest smoothbore Napoleons. General Haupt tried to bring more up. If I had another couple of weeks I could have made it twenty-eight batteries, but things didn’t play out that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Haupt,” Henry replied. “Another good man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You knew him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Briefly, sir. Met him in Harrisburg after the retreat from Union Mills. He sent me on to Washington to report. I heard he died last week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. I’ve sent for Grenville Dodge, who served with me out West, to replace him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I saw Haupt’s handiwork coming up here today, sir. It looks like his men have repaired ten miles or more of rail line today alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. Now back to the question, Hunt. If I give you command of artillery, how do you see it organized?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Under one unified command, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that is you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Answering directly to you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go on.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A single unified command, sir. You are right in that Lee does have my guns, damn it. He must outnumber you”—he paused before correcting himself—“us, in artillery by two or more to one. But many of his gunners are amateurs. It takes months, years, to train good gunners. If you give me a unified command, I can pick the spot for you on any battlefield, concentrate the guns, and tear him apart.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Offensively?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hunt hesitated and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our guns just aren’t effective for that. Don’t get me wrong, sir,” and as he spoke, Hunt warmed to his subject, “a three-inch ordnance rifle, with a good crew, can pick a lone rider off at a thousand yards, but once a battle starts, the smoke, the confusion…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His voice trailed off for a moment, as if he were remembering something.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You had over two hundred guns at Union Mills, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, sir, and we didn’t budge them. We hurt them, at least I think we did, but not enough for Hancock, for Sedgwick, to break through. And in turn, their guns that survived our barrage just shredded our men down in that open field.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What I figured,” Grant said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But if you need to anchor a position, or tear apart reb infantry out in the open coming at you—that I can give you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And Lee’s superior numbers in guns?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let him try and dislodge me. Just let him.” There was a grim ferocity to Hunt’s voice that Grant liked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The job is yours, General Hunt. You report directly to me. I’ll cut the orders tomorrow morning to my corps commanders that all rifled guns are now assigned to your control. I know my corps commanders, and they’ll squawk like crows over that order, so for now, let them keep their Napoleon smoothbores for close-in support, but the rest will go to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hunt looked at him, more than a bit surprised. He had argued for this chance for two years, and now, with almost detached calm, this man from the West had finally given it to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, sir. I won’t let you down.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“See that you don’t,” Grant said. There was a note of dismissal in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Set up your headquarters with mine for now. Pull together what staff you need. I’m promoting you to major general as well so you don’t have to worry about any fights with others. Ord and McPherson know better, but Banks and Burnside…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I understand, sir, and thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just do your job and we’ll get along well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Knowing that their conversation was finished, Hunt saluted and withdrew.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He watched Hunt leave. He sensed he had made the right choice with this man. He had a score to settle with Lee, and by giving Hunt his chance, not just to settle a score, but to prove his theory about a unified command of artillery, he would bind the man to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alone, he walked the length of the parade ground to the flagpole. Someone had told him that for the last month rebel colors had flown from it, torn down just hours ago as their cavalry pulled out ahead of his advance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned against the pole, struck a match against it, and puffed yet another cigar to life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was good to be alone for a few minutes. He looked back at the barracks, aglow with light, staff inside, couriers riding up to the veranda, dismounting, and rushing inside, other couriers coming out, mounting, and galloping off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled. So many of them were boys, playing at this game, actually enjoying it. The day had been a good one, a fairly good march, though he would have preferred to make a few more miles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked off to the southeast. Over there, just about a hundred miles away, was Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wished for a moment that the old stories were true, the stories of Napoleon, Caesar, and Alexander, how they could slip into the mind of their opponents, sow doubt, and learn the deepest of secrets. It would be wonderful to turn the tables on this legendary soldier, to get into his mind as easily as he infiltrated the minds of so many of his opponents.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Foolishness, of course. This was an age of science, of machines, not of magic, and to waste another thought on such foolery was indeed a waste.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he could not slip into the mind of Lee, he must ensure that Lee could never slip into his, never read his heart, never stir a note of discord or, worst of all, fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No, by simply doing that alone I can unnerve him. I’ve set my plans, made so hurriedly, thanks to that fool Sickles. I’d have preferred another three weeks, a month, to marshal more strength, but to have waited after the debacle by Sickles would have played against us, given Lee time to rest, to regather his strength and his nerve for the next encounter.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sensed that just this move alone had most likely caught him off guard. Every other general whom Lee had faced, excepting Sickles, had always erred on the side of caution. Even Meade, in his blind panic to attack at Union Mills, was ultimately driven by caution, fear of how Washington would respond to his being outflanked and cut off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Out west, in California, Grant had heard stories from mountain men who had seen wolves bring down their prey, elk, even old grizzlies. They did not charge in blindly, nor did they run away. Always they lurked, dashing in, pulling back, dashing in, in a hunt that might last for days, wearing their victim down to exhaustion. Always circling, always moving, never letting their victim rest, closing in, limiting their prey’s movements, exhausting them—until at last the throat was bared and the kill made.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He continued to gaze southeastward, toward Baltimore. Chances were that Lee had forced marched back from the Susquehanna this day, concerned by word of the crossing at Harrisburg. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He will have to rest for a few days while I am fresh. He will have to refit, reorganize, rest his men after their mad dash and brilliant campaign of the last week; then they will venture out to meet me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took another puff on his cigar, coughing slightly as he took it out of his mouth and looked at the glowing tip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And yet I know this,")]), _vm._v(" he realized. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Even as I plot my moves, Lee will plot his. Neither of us will get fully what we want. In war one never does until the very last day, when the guns finally fall silent and one side submits.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We both seek the submission of the other, and it won’t come in one battle, one sharp moment of combat. It will be a grinding down, and tens of thousands will die in the weeks to come. I can move along several paths now, but then again so can he.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was Lee sleeping now? He doubted it. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Most likely, even at this moment he is looking toward me, thinking the same thoughts I do.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grant let his cigar drop, and rubbed out the glowing embers with his foot. Turning, he went into his headquarters to get some sleep. Tomorrow would be a very long day.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cf5004","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312342982_ch03.vue
// module id = 75
// module chunks = 0